import { useEffect } from 'react';
import useOnlineStatus from '../../useOnlineStatus';
import useStateControls from '../../useStateControls';

export default function useHandleIsOnline() {
  const isOnline = useOnlineStatus();
  const { setState } = useStateControls();

  useEffect(() => {
    if (!isOnline) setState('error');
  }, [isOnline]);
}
